/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : Home.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Tahir Shaik - tahir@au79consulting.com
 * @date 11-06-2024
 * @description This is the Home Page for the Application
 */

//Importing the required components/functions from the libraries

import React, { useEffect, useState } from "react";
import customConsole from "../../config/customConsole";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  dashboardAction,
  HandleApiActions,
  labCar,
  userManagementApis,
} from "../../redux/actions";
import {
  CustomDataGridTableB,
} from "../../components";
import {
  Card,
  Chip,
  FormControl,
  MenuItem,
  Paper,
  Select,
  Box,
  Grid,
  Typography,
  DialogTitle,
  DialogContent,
  styled,
  Button,
  DialogActions,
  Slide,
  Dialog,
} from "@mui/material";

import appTheme from "../../assets/AppTheme/appTheme";
import { Link, useLocation, useNavigate } from "react-router-dom";
import GraphCard from "../../components/customComponentsV2/dashboard/graph/GraphCard";
import HomologationStatusGraph from "../../components/customComponentsV2/dashboard/graph/HomologationStatusGraph";
import BarGraph from "../../components/customComponentsV2/dashboard/graph/BarGraph";
import RecentActivities from "../../components/customComponentsV2/dashboard/pages/RecentActivities";
import { componentStyle } from "../../config/appTheme";
import CustomFilterV2 from "../../components/customComponentsV2/common/filter/CustomFilterV2";
import CustomSelectV2 from "../../components/customComponentsV2/common/select/CustomSelectV2";
import ProjectVariantSearchbar from "../../components/customComponentsV2/common/projectSearchbar/ProjectvariantSearchbar";
import CustomDialogBoxV2 from "../../components/customComponentsV2/common/customDialogBox/CustomDialogBoxV2";
import CustomButtonV2 from "../../components/customComponentsV2/common/button/CustomButtonV2";
import reportTemplateAction from "../../redux/actions/reporting/reportTemplateActions";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const hsOptions = {
  // title: "Homologation Status",
  pieHole: 0.47,
  is3D: false,
  legend: {
    position: "bottom",
    alignment: "center",
  },
  colors: [
    "#007CB0", // Total
    "#26890D", // Completed
  ],
  slices: {
    0: { visibleInLegend: true }, // Total
    1: { visibleInLegend: true }, // Completed
  },
  // titleTextStyle: {
  //   fontSize: 18,
  //   bold: true,
  //   color: "#333333",
  //   alignment: "center",
  // },
};

const tsOptions = {
  // title: "Tickets Status",
  legend: { position: "none" },
  vAxis: {
    viewWindow: {
      min: 0, // Ensures the minimum value on the Y-axis is 0
    },
  },
  // colors: [
  //   "#C55A11", // Draft
  //   "#00B0F0", // New
  //   "#C5E0B4", // Artifact Confirmation
  //   "#AFABAB", // Evidence Submission
  //   "#92D050", // Evidence Review
  //   "#00B050", // Testing at Technical Service
  //   "#FF0000", // Resolved
  // ],
  // titleTextStyle: {
  //   fontSize: 18,
  //   bold: true,
  //   color: "#333333",
  //   alignment: "center",
  // },
};

const ultOptions = {
  // title: "User Level Tickets",
  legend: { position: "none" },
  // titleTextStyle: {
  //   fontSize: 18,
  //   bold: true,
  //   color: "#333333",
  //   alignment: "center",
  // },
};

const ticketStatusNames = {
  101: "Draft",
  100: "New",
  150: "Confirm Legal Requirements",
  200: "Artifact Confirmation",
  300: "Evidence Submission",
  400: "Evidence Review",
  500: "Testing at TA reviewers",
  600: "Resolved",
  999: "Closed Incomplete",
};
const resolvedTicketsStatus = [600];

const tsChartsStyles = {
  101: "#D0D0CE", // Draft
  100: "#9DD4CF", // New
  200: "#007680", // Artifact Confirmation
  300: "#004F59", // Evidence Submission
  400: "#C4D600", // Evidence Review
  500: "#009A44", // Testing at TA reviewers
  600: "#2C5234", // Resolved
};

//Main Home Function component
function Home() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  /* useSelectors */
  const usersDetails = useSelector((state) => state.userManagementReducer);

  /* -------------- useSelectors -------------- */
  // const { projectDetails, selectedProject, selectedVariant } = useSelector(
  //   (state) => state.labCarReducer,
  //   shallowEqual
  // );
  const { variantInfo: variantDetails } = useSelector(
    (state) => state.variantReducer,
    shallowEqual,
  );

  const selectedProject = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  const selectedVariant = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );

  const profileDetails = useSelector((store) => store.profileReducer);

  // Extract role_type from profileDetails
  const roleType = profileDetails?.profile?.role_details?.role_type;


  const techUser = roleType === 1;

  /* Project-related state variables */


  /* Variant states */
  // const [variantOptionsList, setVariantOptionsList] = useState([]);
  // const [selectedVariantDetails, setSelectedVariantDetails] = useState(null);

  // Contains the fetched ticket status data
  const [ticketsStatusData, setTicketsStatusData] = useState([]);
  // Contains the filtered fetched ticket status data
  const [ticketsStatusList, setTicketsStatusList] = useState([]);

  // Vehicle Functions Options List
  const [vehicleFunctionList, setVehicleFunctionList] = useState([]);

  // Users
  const [tsUsersList, setTsUsersList] = useState([]);

  // Homologation Status States
  const [hsVfOptionsList, setHsVfOptionsList] = useState([]);
  const [selectedHsVf, setSelectedHsVf] = useState(0);
  // Tickets Status States
  const [tsVfOptionsList, setTsVfOptionsList] = useState([]);
  const [selectedTsVf, setSelectedTsVf] = useState(0);
  // User Level Tickets States
  const [ultUsersOptionsList, setUltUsersOptionsList] = useState([]);
  const [selectedUltUser, setSelectedUltUser] = useState(0);

  // EE Dialog
  const [isEEDialogOpen, setIsEEDialogOpen] = useState(false);
  const [eeDialogData, setEEDialogData] = useState(null);

  const [homologationStatus, setHomologationStatus] = useState([
    ["Status", "Tickets"],
    ["Target", 0],
    ["Completion", 0],
  ]);
  const [totalHsTickets, setTotalHsTickets] = useState(0);

  const [ticketsStatus, setTicketsStatus] = useState([
    ["Status", "Count"],
    ["Draft", 0],
    ["New", 0],
    ["AC", 0],
    ["ES", 0],
    ["ER", 0],
    ["WT", 0],
    ["Resolved", 0],
  ]);
  const [totalVfTickets, setTotalVfTickets] = useState(0);
  const [userLevelTickets, setUserLevelTickets] = useState([
    ["Status", "Count"],
    ["Draft", 0],
    ["New", 0],
    ["Artifact Confirmation", 0],
    ["Evidence Submission", 0],
    ["Evidence Review", 0],
    ["Testing at TA reviewers", 0],
    ["Resolved", 0],
  ]);
  const [totalUserTickets, setTotalUserTickets] = useState(0);

  // Filters Icon
  const [anchorElHsFilter, setAnchorElHsFilter] = useState(null);
  const [anchorElTsFilter, setAnchorElTsFilter] = useState(null);
  const [anchorElUltFilter, setAnchorElUltFilter] = useState(null);

  const [openHsFilter, setOpenHsFilter] = useState(false);
  const [openTsFilter, setOpenTsFilter] = useState(false);
  const [openUltFilter, setOpenUltFilter] = useState(false);

  const [hsFilteredData, setHsFilteredData] = useState(null);
  const [tsFilteredData, setTsFilteredData] = useState(null);
  const [ultFilteredData, setUltFilteredData] = useState(null);

  const templates = useSelector(
    (state) => state.reportTemplateReducer?.items || [],
  );

  const [generateOpen, setGenerateOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [loadingGenerate, setLoadingGenerate] = useState(false);

  const handleHsFilterIconClick = (event) => {
    setAnchorElHsFilter(event.currentTarget);
    setOpenHsFilter(true);
  };
  const handleTsFilterIconClick = (event) => {
    setAnchorElTsFilter(event.currentTarget);
    setOpenTsFilter(true);
  };
  const handleUltFilterIconClick = (event) => {
    setAnchorElUltFilter(event.currentTarget);
    setOpenUltFilter(true);
  };

  const handleHsFilterIconClose = () => {
    setAnchorElHsFilter(null);
    setOpenHsFilter(false);
  };
  const handleTsFilterIconClose = () => {
    setAnchorElTsFilter(null);
    setOpenTsFilter(false);
  };
  const handleUltFilterIconClose = () => {
    setAnchorElUltFilter(null);
    setOpenUltFilter(false);
  };

  // Functions to update the charts data
  const updateHomologationStatus = ({ pending, resolved, total }) => {
    setTotalHsTickets(total);
    setHomologationStatus([
      ["Status", "Tickets"],
      ["Target", pending],
      ["Completion", resolved],
    ]);
  };

  const handleGenerate = async () => {
    try {
      setLoadingGenerate(true);

      const resp = await dispatch(
        HandleApiActions({
          api_name: "/PCM/reports/generate",
          https_method: "POST",
          params: {
            scope_type: "VEHICLE_PROGRAM",
            project_id: selectedProjectId, // ensure this exists
            variant_id: selectedVariant?.variant_id,
            template_id: selectedTemplateId,
          },
          show_toast: true,
        }),
      );

      const s3Key = resp?.data?.s3_key;
      if (!s3Key) return;

      // Get signed URL
      const signed = await dispatch(
        HandleApiActions({
          api_name: "/FSM/v1/assets/download/get/presigned-url",
          https_method: "GET",
          params: { key: s3Key },
          show_toast: false,
        }),
      );

      const url = signed?.data?.url;
      if (url) window.open(url, "_blank");

      setGenerateOpen(false);
      setSelectedTemplateId("");
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingGenerate(false);
    }
  };

  // Function to get the tickets status
  const getTicketsStatus = async (projectId, variantId) => {
    const apiDetails = dashboardAction.get_tickets_status;
    customConsole({
      ...apiDetails,
      params: {
        ...(projectId && { project_id: projectId }),
        // ...(variantId && { variant_id: variantId }),
      },
    });
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          ...(projectId && { project_id: projectId }),
          ...(variantId && { variant_id: variantId }),
        },
      }),
    );
    if (resp.error) {
      setTicketsStatusData([]);
    } else {
      setTicketsStatusData(resp.data);
    }
  };

  // Function to update the charts data
  const updateTicketsStatus = (statusData) => {
    // Initialize counts for each status
    const statusCounts = Object.keys(ticketStatusNames)?.reduce(
      (acc, status) => {
        acc[status] = 0;
        return acc;
      },
      {},
    );

    // Count the occurrences of each status
    statusData?.forEach(({ ticket_status }) => {
      if (statusCounts.hasOwnProperty(ticket_status)) {
        statusCounts[ticket_status] += 1;
      }
    });

    // Calculate total count of all tickets
    const totalCount = Object.values(statusCounts).reduce(
      (acc, count) => acc + count,
      0,
    );
    setTotalVfTickets(totalCount);

    // Construct the updated status array, including all statuses with their counts
    const updatedStatus = [
      ["Status", "Count", { role: "style" }, { role: "annotation" }],
      [
        "Draft",
        statusCounts[101],
        tsChartsStyles[101],
        statusCounts[101],
        "Draft",
      ],
      ["New", statusCounts[100], tsChartsStyles[100], statusCounts[100], "New"],
      [
        "Artifact Confirmation [AC]",
        statusCounts[200],
        tsChartsStyles[200],
        statusCounts[200],
        "AC",
      ],
      [
        "Evidence Submission [ES]",
        statusCounts[300],
        tsChartsStyles[300],
        statusCounts[300],
        "ES",
      ],
      [
        "Evidence Review [ER]",
        statusCounts[400],
        tsChartsStyles[400],
        statusCounts[400],
        "ER",
      ],
      [
        "Witness Testing [WT]",
        statusCounts[500],
        tsChartsStyles[500],
        statusCounts[500],
        "WT",
      ],
      [
        "Resolved",
        statusCounts[600],
        tsChartsStyles[600],
        statusCounts[600],
        "Resolved",
      ],
    ];

    // Update the state with the new status data
    setTicketsStatus(updatedStatus);
  };

  // Function to update the charts data
  const updateUserTicketsStatus = (statusData) => {
    // Initialize counts for each status
    const statusCounts = Object.keys(ticketStatusNames).reduce(
      (acc, status) => {
        acc[status] = 0;
        return acc;
      },
      {},
    );

    // Count the occurrences of each status
    statusData.forEach(({ ticket_status }) => {
      if (statusCounts.hasOwnProperty(ticket_status)) {
        statusCounts[ticket_status] += 1;
      }
    });

    // Calculate total count of all tickets
    const totalCount = Object.values(statusCounts).reduce(
      (acc, count) => acc + count,
      0,
    );
    setTotalUserTickets(totalCount);

    // Construct the updated status array, including all statuses with their counts
    const updatedStatus = [
      ["Status", "Count", { role: "style" }, { role: "annotation" }],
      [
        "Draft",
        statusCounts[101],
        tsChartsStyles[101],
        statusCounts[101],
        "Draft",
      ],
      ["New", statusCounts[100], tsChartsStyles[100], statusCounts[100], "New"],
      [
        "Artifact Confirmation [AC]",
        statusCounts[200],
        tsChartsStyles[200],
        statusCounts[200],
        "AC",
      ],
      [
        "Evidence Submission [ES]",
        statusCounts[300],
        tsChartsStyles[300],
        statusCounts[300],
        "ES",
      ],
      [
        "Evidence Review [ER]",
        statusCounts[400],
        tsChartsStyles[400],
        statusCounts[400],
        "ER",
      ],
      [
        "Witness Testing [WT]",
        statusCounts[500],
        tsChartsStyles[500],
        statusCounts[500],
        "WT",
      ],
      [
        "Resolved",
        statusCounts[600],
        tsChartsStyles[600],
        statusCounts[600],
        "Resolved",
      ],
    ];

    // Update the state with the new status data
    setUserLevelTickets(updatedStatus);
  };

  /* UseEffects */
  useEffect(() => {
    // Get the project details
    dispatch(HandleApiActions({ ...labCar.get_project_details }));
  }, []);

  useEffect(() => {
    if (!generateOpen) return;

    dispatch(
      HandleApiActions({
        ...reportTemplateAction.get_templates,
      }),
    );
  }, [generateOpen]);

  // useEffect(() => {
  //   // Project options list
  //   let filteredProjectOptionsList = projectDetails
  //     ?.map((el) => {
  //       return {
  //         value: el?.project_id,
  //         label: el?.name,
  //       };
  //     })
  //     ?.sort((a, b) => a.label.localeCompare(b.label));

  //   setProjectOptionsList(filteredProjectOptionsList);

  //   /* Store first project in the redux store */
  //   if (!(selectedProject?.value && selectedProject?.label)) {
  //     dispatch(selectProjectAction(filteredProjectOptionsList?.[0]));
  //   }
  // }, [projectDetails]);

  /* Get selected project details */
  // useEffect(() => {
  //   if (selectedProject) {
  //     let filteredSelectedProjectDetails = projectDetails?.find(
  //       (el) => el?.project_id === selectedProject?.value
  //     );
  //     setSelectedProjectDetails(filteredSelectedProjectDetails);
  //   }

  //   /* Selected variant will be null, when the project is changed */
  //   dispatch(selectVariantAction(null));
  // }, [selectedProject]);

  useEffect(() => {
    // Make the stated to default, when the project is changed
    setTicketsStatusData([]);
    setTicketsStatusList([]);
    setVehicleFunctionList([]);
    setTsUsersList([]);
    setHsVfOptionsList([]);
    setSelectedHsVf(0);
    setTsVfOptionsList([]);
    setSelectedTsVf(0);
    setHsFilteredData(0);
    setTsFilteredData(0);
    setUltFilteredData(0);
    setUltUsersOptionsList([]);
    setSelectedUltUser(0);
    setTotalHsTickets(0);
    setTotalVfTickets(0);
    setTotalUserTickets(0);
  }, [selectedProject]);



  useEffect(() => {
    getTicketsStatus(
      isNaN(Number(selectedProject?.project_id))
        ? undefined
        : Number(selectedProject?.project_id),
      isNaN(Number(selectedVariant?.variant_id))
        ? undefined
        : Number(selectedVariant?.variant_id),
    );
  }, [selectedProject, selectedVariant]);

  useEffect(() => {
    // Filtered Tickets Status List
    let filteredTicketStatusList = ticketsStatusData?.map((ts) => {
      return {
        ticket_id: ts?.ticket_id,
        ticket_status: ts?.ticket_status,
        ticket_status_name: ticketStatusNames[ts?.ticket_status],
        vf_ids: ts?.vf_ids?.map((vf) => String(vf)),
        oem_user_ids: ts?.oem_user_ids?.map((oem) => String(oem)),
        tech_service_user_ids: ts?.tech_service_user_ids?.map((tsu) =>
          String(tsu),
        ),
      };
    });
    setTicketsStatusList(filteredTicketStatusList);

    // Filtered Vehicle Functions List
    const uniqueVehicleFunctions = ticketsStatusData?.reduce((acc, ticket) => {
      ticket?.vehicle_functions?.forEach((vf) => {
        if (!acc?.some((item) => item?.id == vf?.id)) {
          acc.push(vf);
        }
      });
      return acc;
    }, []);

    // Vehicle functions list
    setVehicleFunctionList(uniqueVehicleFunctions);



    const isUserExists = (accumulator, user) => {
      return accumulator?.some(
        (existingUser) => existingUser?.user_id === user?.user_id,
      );
    };

    const addUniqueUsers = (accumulator, users = []) => {
      users.forEach((user) => {
        if (!isUserExists(accumulator, user)) {
          accumulator.push(user);
        }
      });
      return accumulator;
    };

    const uniqueUsers = ticketsStatusData?.reduce((accumulator, current) => {
      const users = [
        ...(current?.tech_user_details || []),
        ...(current?.oem_user_details || []),
      ];

      return addUniqueUsers(accumulator, users);
    }, []);
    // Filtered Users List
    setTsUsersList(uniqueUsers);
  }, [ticketsStatusData]);

  useEffect(() => {
    // Handle the Homologation Status
    const totalTicketsCount = ticketsStatusList?.length || 0;

    let resolvedTicketsCount =
      ticketsStatusList?.filter((ts) =>
        resolvedTicketsStatus?.includes(Number(ts.ticket_status)),
      ).length || 0;



    updateHomologationStatus({
      pending: totalTicketsCount - resolvedTicketsCount,
      resolved: resolvedTicketsCount,
      total: totalTicketsCount,
    });

    // Handle the Tickets Status
    updateTicketsStatus(ticketsStatusList);

    // Handle the User Tickets Status
    updateUserTicketsStatus(ticketsStatusList);
  }, [ticketsStatusList]);

  useEffect(() => {
    let filteredVfOptionsList = vehicleFunctionList?.map((vf) => {
      return {
        value: vf.id,
        label: vf.name,
      };
    });
    // Add the "All" option at the top
    filteredVfOptionsList = [
      { value: 0, label: "All" },
      ...filteredVfOptionsList,
    ];

    // Homologation Status vfs
    setHsVfOptionsList(filteredVfOptionsList);
    // Tickets Status vfs
    setTsVfOptionsList(filteredVfOptionsList);
  }, [vehicleFunctionList]);

  useEffect(() => {
    // Filter user list
    let filteredUsersList = tsUsersList?.map((us) => {
      return {
        value: us?.user_id,
        label: `${us?.name} - ${us?.email}`,
        // label: `${us?.name} - ${us?.email} - ${us?.role_id}`,
      };
    });
    // Add the "All" option at the top
    filteredUsersList = [{ value: 0, label: "All" }, ...filteredUsersList];
    setUltUsersOptionsList(filteredUsersList);
  }, [tsUsersList]);

  useEffect(() => {
    // Homologation Status
    let filteredTicketsStatusList = selectedHsVf
      ? ticketsStatusList?.filter((hs) =>
        hs?.vf_ids?.includes(String(selectedHsVf)),
      )
      : ticketsStatusList;

    // Handle the Homologation Status
    const totalTicketsCount = filteredTicketsStatusList?.length || 0;

    let resolvedTicketsCount =
      filteredTicketsStatusList?.filter((ts) =>
        resolvedTicketsStatus?.includes(Number(ts.ticket_status)),
      ).length || 0;

    updateHomologationStatus({
      pending: totalTicketsCount - resolvedTicketsCount,
      resolved: resolvedTicketsCount,
      total: totalTicketsCount,
    });
  }, [selectedHsVf]);

  useEffect(() => {
    // Tickets Status
    let filteredTicketsStatusList = selectedTsVf
      ? ticketsStatusList?.filter((ts) =>
        ts?.vf_ids?.includes(String(selectedTsVf)),
      )
      : ticketsStatusList;

    // Handle the Tickets Status
    updateTicketsStatus(filteredTicketsStatusList);
  }, [selectedTsVf]);

  useEffect(() => {
    // User Level Tickets
    let filteredTicketsStatusList = selectedUltUser
      ? ticketsStatusList?.filter(
        (ult) =>
          ult?.oem_user_ids?.includes(String(selectedUltUser)) ||
          ult?.tech_service_user_ids?.includes(String(selectedUltUser)),
      )
      : ticketsStatusList;

    // Handle the User Tickets Status
    updateUserTicketsStatus(filteredTicketsStatusList);
  }, [selectedUltUser]);

  useEffect(() => {
    customConsole({ ticketsStatusData });
    customConsole({ ticketsStatusList });
    customConsole({ vehicleFunctionList });
    customConsole({ tsUsersList });
    customConsole({ selectedHsVf });
  }, [
    ticketsStatusData,
    ticketsStatusList,
    vehicleFunctionList,
    tsUsersList,
    selectedHsVf,
  ]);

  // ----------------------Bharathan-----------------------------

  const [activeTab, setActiveTab] = useState(0);
  const [ticketTableRowsData, setTicketTableRowsData] = useState([]);
  const [eeCTableRowsData, setEECTableRowsData] = useState([]);
  const [swMTableRowsData, setSWMTableRowsData] = useState([]);
  const [statusDetails, setStatusDetails] = useState([]);
  const [recentActivitiesDetails, setRecentActivitiesDetails] = useState([]);
  const [ticketDetails, setTicketDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState(5); // Countdown timer in seconds
  const [intervalId, setIntervalId] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [currentTicketId, setCurrentTicketId] = useState(null);
  const [userDetails, setUserDetails] = useState([]);
  const [legalDialogData, setLegalDialogData] = useState(null);
  const [isLegalDialogOpen, setIsLegalDialogOpen] = useState(false);

  const getDefaultValue = (arr) => (arr && arr.length > 0 ? arr[0] : 0);

  const project = getDefaultValue(statusDetails?.project_details);
  const swm = getDefaultValue(statusDetails?.swm_details);
  const ee = getDefaultValue(statusDetails?.ee_details);
  const intr = getDefaultValue(statusDetails?.intr_details);
  const deps = getDefaultValue(statusDetails?.dependencies_details);
  const selectedProjectId = selectedProject?.project_id;

  const linkModuleType = { SWM: 1, EE: 2 };

  useEffect(() => {
    // Get the tickets status
    if (selectedProject?.project_id && selectedVariant?.variant_id) {
      getTicketDetails(
        Number(selectedProject?.project_id),
        Number(selectedVariant?.variant_id),
      );
    }
  }, [selectedProject, selectedVariant]);

  useEffect(() => {
    // Get the tickets status
    if (selectedProject?.project_id) {
      // getTicketDetails(Number(selectedProjectDetails?.project_id));
      getRecentActivitiesDetails(Number(selectedProject?.project_id));
      // getStatusDetails(Number(selectedProject?.project_id));
    }
  }, [selectedProject]);

  useEffect(() => {
    getStatusDetails(Number(selectedProject?.project_id));
  }, [selectedVariant]);

  const getTicketDetailsTU = async (projectId) => {
    let apiDetails = dashboardAction.get_tickets;
    delete apiDetails.action_type;
    customConsole({
      ...apiDetails,
      params: {
        project_id: projectId,
      },
      show_toast: false,
    });
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          // project_id: projectId,
        },
        show_toast: false,
      }),
    );
    if (resp.error) {
      setTicketDetails([]);
    } else {
      setTicketDetails(resp.data);
    }
  };

  const handleTSFilterButton = (action) => {
    switch (action) {
      case "cancel":
        handleTsFilterIconClose();
        break; // prevents fall-through
      case "apply":
        setSelectedTsVf(tsFilteredData);
        handleTsFilterIconClose();
        break;
      default:
        console.warn(`Unhandled action: ${action}`);
    }
  };
  const handleHsFilterButton = (action) => {
    switch (action) {
      case "cancel":
        handleHsFilterIconClose();
        break; // prevents fall-through
      case "apply":
        setSelectedHsVf(hsFilteredData);
        handleHsFilterIconClose();
        break;
      default:
        console.warn(`Unhandled action: ${action}`);
    }
  };

  const handleUltFilterButton = (action) => {
    switch (action) {
      case "cancel":
        handleUltFilterIconClose();
        break; // prevents fall-through
      case "apply":
        setSelectedUltUser(ultFilteredData);
        handleUltFilterIconClose();
        break;
      default:
        console.warn(`Unhandled action: ${action}`);
    }
  };

  useEffect(() => {
    // Get the tickets status
    getTicketDetailsTU();
  }, []);

  const getTicketDetails = async (projectId, variantId) => {
    let apiDetails = dashboardAction.get_tickets;
    delete apiDetails.action_type;
    customConsole({
      ...apiDetails,
      params: {
        project_id: projectId,
        variant_id: variantId,
      },
      show_toast: false,
    });
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: projectId,
          variant_id: variantId,
        },
        show_toast: false,
      }),
    );
    if (resp.error) {
      setTicketDetails([]);
    } else {
      setTicketDetails(resp.data);
    }
  };

  const getStatusDetails = async (projectId) => {

    let apiDetails = dashboardAction.get_dash_board_status;
    delete apiDetails.action_type;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: projectId,
          // variant_id: selectedVariant?.variant_id
        },
        show_toast: false,
      }),
    );
    if (resp.error) {
      setStatusDetails([]);
    } else {
      setStatusDetails(resp.data);
    }
  };

  const getRecentActivitiesDetails = async (projectId) => {
    let apiDetails = dashboardAction.get_dash_board_activities;
    delete apiDetails.action_type;

    customConsole({
      ...apiDetails,
      params: {
        project_id: projectId,
      },
      show_toast: false,
    });

    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          project_id: projectId,
        },
        show_toast: false,
      }),
    );
    if (resp.error) {
      setRecentActivitiesDetails({});
    } else {
      setRecentActivitiesDetails(resp.data);
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const eeComponentDetails = recentActivitiesDetails.eeComponentDetails;
  const swmDetails = recentActivitiesDetails.swmDetails;

  useEffect(() => {
    if (ticketDetails) {
      const filteredTicketList = ticketDetails
        ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
        ?.slice(0, 10)
        ?.map((item, index) => ({
          id: index + 1,
          intr_id: item?.intr_id,
          tech_service_users: item?.tech_service_users,
          oem_users: item?.oem_users,
          users: item?.tech_service_users || item?.oem_users,
          ticket_id: item?.ticket_id,
          status: item?.status,
          ls_details: item?.ls_details,
          lr_details: item?.lr_details,
          swm_details: item?.swm_details,
          ee_details: item?.ee_details,
          description: item?.description,
          project_status: item?.project_details?.project_id || item?.status,
          created_by: item?.created_by,
          updated_at: item?.updated_at,
          updated_by: item?.updated_by,
          allData: item,
        }));

      setTicketTableRowsData(filteredTicketList);
    }
  }, [ticketDetails]);

  useEffect(() => {
    if (eeComponentDetails) {
      const filteredeeComponentDetails = eeComponentDetails
        ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
        ?.slice(0, 10)
        ?.map((item) => ({
          id: item?.ee_id,
          assembly_number: item?.assembly_number,
          supplier_name: item?.supplier_name,
          description: item?.description,
          version: item?.version,
          created_by: item?.created_by,
          updated_at: item?.updated_at,
          allData: item,
        }));

      setEECTableRowsData(filteredeeComponentDetails);
    }
  }, [eeComponentDetails]);

  useEffect(() => {
    if (swmDetails) {
      const filteredswmDetails = swmDetails
        ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
        ?.slice(0, 10)
        ?.map((item) => ({
          id: item?.swm_id,
          name: item?.name,
          description: item?.description,
          version: item?.version,
          vehicle_functions: item?.vehicle_functions,
          created_by: item?.created_by,
          allData: item,
        }));

      setSWMTableRowsData(filteredswmDetails);
    }
  }, [swmDetails]);

  const getTicketStatusName = (statusCode) => {
    return ticketStatus[statusCode] || "-";
  };



  useEffect(() => {
    if (!open) return; // Prevent interval from creating when dialog is closed.

    setTimer(5); // Reset timer here so it’s set BEFORE interval starts.

    const id = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          handleRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(id);
    };
  }, [open]);

  const LinkButton = styled(Button)(({ theme }) => ({
    textTransform: "none",
    color: theme.palette.primary.main,
    textDecoration: "underline",
    padding: 0,
    minWidth: "auto",
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
  }));

  const CountdownTimer = styled(Typography)(({ theme }) => ({
    backgroundColor: "green",
    color: "white",
    borderRadius: 0,
    textAlign: "center",
    P: 1,
    cursor: "pointer",
  }));

  const handleClickOpen = (ticket_id) => {
    setCurrentTicketId(ticket_id);
    setOpen(true);
    setTimer(5);
  };

  const handleClose = () => {
    setOpen(false);
    if (intervalId) {
      clearInterval(intervalId);
    }
  };

  const handleRedirect = () => {
    setOpen(false);
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
    if (currentTicketId) {
      const linkType = currentTicketId.startsWith("INC")
        ? "incident.do"
        : "sn_customerservice_case.do";
      window.open(
        `https://ven07074.service-now.com/${linkType}?sysparm_query=number=${currentTicketId}`,
        "_blank",
      );
    }
  };


  //Function to handle Toggle drawer open/closed
  const toggleDialog = (newOpen) => () => {
    setIsDialogOpen(newOpen);
  };

  //Function to handle EE Toggle drawer open/closed
  const toggleEEDialog = (newOpen) => () => {
    setIsEEDialogOpen(newOpen);
  };

  //Function to handle Toggle Legal Dialog open/closed
  const toggleLegalDialog = (newOpen) => () => {
    setIsLegalDialogOpen(newOpen);
  };

  // Handle button click to open drawer with ticket details
  const handleViewButtonClick = (item) => {
    const modules = item?.dependencies?.software_modules || [];
    const vehicleFunctions = item?.swm_details?.vehicle_functions;

    // Map the modules to include both module details and their corresponding ee_details
    const items2 = modules.map((module) => ({
      swm_id: module?.swm_id,
      name: module?.name,
      version: module?.version,
      description: module?.description,
      ee_details: module?.ee_details || [],
    }));

    const eeDetails = modules.flatMap((module) => module?.ee_details) || [];

    setDialogData({
      heading1: `Vehicle Functions`,
      items1:
        vehicleFunctions?.map((vehicleFunction) => ({
          name: vehicleFunction?.name,
          abbreviation: vehicleFunction?.abbreviation,
        })) || [],
      heading2: `Dependent Software Modules`,
      items2: items2, // Use the combined items
      heading3: `EE Details`,
      items3: eeDetails.map((ee) => ({
        ee_id: ee?.ee_id,
        assembly_number: ee?.assembly_number,
        description: ee?.description,
        supplier_name: ee?.supplier_name,
        version: ee?.version,
      })),
    });

    toggleDialog(true)();
  };

  const [userDetailsMap, setUserDetailsMap] = useState(new Map());
  const [usersDetail, setUsersDetail] = useState(new Map());

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const apiDetails = userManagementApis?.get_users_list_pa;
        delete apiDetails.action_type;
        const resp = await dispatch(
          HandleApiActions({
            ...apiDetails,
            show_toast: false,
          }),
        );

        if (!resp.error) {
          // Create a map for quick lookup
          const users = resp?.data;
          const userMap = new Map(
            users.map((user) => [user?.user_id, user?.fullname]),
          );
          setUserDetailsMap(userMap);
          setUsersDetail(users);
        }
      } catch (error) {
        console.error("Failed to fetch user details:", error);
      }
    };

    fetchUserDetails();
  }, []);

  // Function to get user full name by ID
  const getUserFullNameById = (userId) => {
    return userDetailsMap.get(userId) || userId;
  };

  // Define default user details in case user details are not found
  const defaultUsersDetails = { fullname: "User removed" };

  // Retrieve user details by ID or fallback to default
  const getUsersDetailsById = (userId) => {
    return userDetailsMap?.get(userId || defaultUsersDetails);
  };

  const handleSWMViewButtonClick = (item) => {
    const modules = item?.dependencies?.software_modules || [];
    const vehicleFunctions = item?.swm_details?.vehicle_functions;

    // Map the modules to include both module details and their corresponding ee_details
    const items2 = modules?.map((module) => ({
      swm_id: module?.swm_id,
      name: module?.name,
      version: module?.version,
      description: module?.description,
      ee_details: module?.ee_details || [], // Include ee_details in each module
    }));

    const eeDetails = modules?.flatMap((module) => module?.ee_details) || [];

    setDialogData({
      heading1: `Vehicle Functions`,
      items1:
        vehicleFunctions?.map((vehicleFunction) => ({
          name: vehicleFunction?.name,
          abbreviation: vehicleFunction?.abbreviation,
        })) || [],
      heading2: `Dependent Software Modules`,
      items2: items2, // Use the combined items
      heading3: `EE Details`,
      items3: eeDetails.map((ee) => ({
        ee_id: ee?.ee_id,
        assembly_number: ee?.assembly_number,
        description: ee?.description,
        supplier_name: ee?.supplier_name,
        version: ee?.version,
      })),
    });

    toggleDialog(true)();
  };

  // Handle button click to open drawer with ticket details
  const handleEEViewButtonClick = (item) => {
    const modules = item?.dependencies?.ee_components || [];
    const vehicleSystems = item?.ee_details?.vehicle_systems;

    setEEDialogData({
      heading1: `Vehicle Systems`,
      items1:
        vehicleSystems?.map((vs) => ({
          name: vs?.name,
          abbreviation: vs?.abbreviation,
        })) || [],
      heading2: `Dependent EE Components`,
      items2: modules.map((ee) => ({
        ee_id: ee?.ee_id,
        assembly_number: ee?.assembly_number,
        description: ee?.description,
        supplier_name: ee?.supplier_name,
        version: ee?.version,
      })),
    });

    toggleEEDialog(true)();
  };

  const handleLEGALViewButtonClick = (item) => {
    const lr_details = item?.lr_details || {};
    const ls_details = item?.ls_details || {};

    // Directly map lr_details to items2
    const items2 = [
      {
        lr_id: lr_details.lr_id,
        chapter: lr_details.chapter,
        description: lr_details.description,
        req_number: lr_details.req_number,
      },
    ];

    // Create items3 from ls_details
    const items3 = [
      {
        ls_id: ls_details.ls_id,
        standard_number: ls_details.standard_number,
        name: ls_details.name,
        revision: ls_details.revision,
        description: ls_details.description,
        chapters: ls_details.chapters,
      },
    ];

    setLegalDialogData({
      heading2: `Legal Requirement`,
      items2: items2,
      items3: items3,
    });

    toggleLegalDialog(true)();
  };

  const TICKET_COLUMNS = [
    {
      field: "intr_id",
      headerName: "INTERSECTION ID",
      headerAlign: "center",
      width: 140,
      renderCell: (params) => (
        <Box sx={{ textAlign: "center", fontSize: "12px" }}>
          {params?.value || "-"}
        </Box>
      ),
    },
    {
      field: "ticket_id",
      headerName: "TICKET ID",
      headerAlign: "center",
      width: 100,
      renderCell: (params) => (
        <Box sx={{ textAlign: "center" }}>
          <LinkButton
            onClick={() => handleClickOpen(params.value)}
            sx={{ fontSize: "12px" }}
          >
            {params?.value}
          </LinkButton>

          <CustomDialogBoxV2
            open={open}
            onClose={handleClose}
            title={<Box></Box>}
          >
            <Typography
              variant="h6"
              sx={{ ...componentStyle.font.cardHeadder }}
            >
              Redirecting to ServiceNow Ticketing tool!
            </Typography>

            <CountdownTimer
              onClick={handleRedirect}

            >
              Redirectiong in ({timer}) sec..
            </CountdownTimer>
          </CustomDialogBoxV2>
        </Box>
      ),
    },
    {
      field: "project_status",
      headerName: "STATUS",
      headerAlign: "center",
      width: 180,
      renderCell: (params) => {
        const projectId = params?.row?.project_details?.project_id;
        const status = params?.row?.status;

        return (
          <Link
            to={`/dashboard/type-approval?project_id=${selectedProjectId}&status=${status}`}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Typography sx={{ textTransform: "uppercase" }}>
                {getTicketStatusName(status || "-")}
              </Typography>
            </Box>
          </Link>
        );
      },
    },
    {
      field: "updated_by",
      headerName: "CHANGED BY",
      headerAlign: "center",
      width: 140,
      renderCell: (params) => {
        const userId = params?.value;
        const userName = getUserFullNameById(userId);
        return <Box sx={{ textAlign: "center" }}>{userName || userId}</Box>;
      },
    },
    {
      field: "reason",
      headerName: "REASON",
      headerAlign: "center",
      width: 140,
    },
    {
      field: "swm_details",
      headerName: "SOFTWARE MODULE",
      headerAlign: "left",
      width: 200,
      renderCell: (params) => {
        const { swm_details } = params?.row;
        return (
          <Box sx={{ textAlign: "left", fontSize: "12px" }}>
            <Box>
              <strong>Name:</strong> {swm_details?.name || "-"}
            </Box>
            <Box>
              <strong>Version:</strong> {swm_details?.version || "-"}
            </Box>
            <Box>
              <strong>Description:</strong> {swm_details?.description || "-"}
            </Box>
            {swm_details?.name ? (
              <Box sx={{ textAlign: "left", marginTop: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => handleSWMViewButtonClick(params?.row?.allData)}
                  sx={{ ...appTheme.commonBtnStyle, fontSize: "10px" }}
                  size="small"
                >
                  View more{" >>"}
                </Button>
              </Box>
            ) : null}
          </Box>
        );
      },
    },
    {
      field: "ls_lr_details",
      headerName: "LEGAL DETAILS",
      headerAlign: "left",
      width: 250,

      renderCell: (params) => {
        const { lr_details, ls_details } = params?.row;
        return (
          <Box sx={{ textAlign: "left", fontSize: "12px" }}>
            <Box>
              <strong>Chapter:</strong> {lr_details?.chapter || "-"}
            </Box>
            <Box>
              <strong>Requirement Number:</strong>{" "}
              {lr_details?.req_number || "-"}
            </Box>
            <Box>
              <strong>Standard Number:</strong>{" "}
              {ls_details?.standard_number || "-"}
            </Box>
            <Box>
              <strong>Revision:</strong> {ls_details?.revision || "-"}
            </Box>
            <Box sx={{ textAlign: "left", marginTop: 1, fontSize: "10px" }}>
              <Button
                variant="contained"
                onClick={() => handleLEGALViewButtonClick(params?.row?.allData)}
                sx={{ ...appTheme.commonBtnStyle, fontSize: "10px" }}
                size="small"
              >
                View more{" >>"}
              </Button>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "ee_details",
      headerName: "EE COMPONENT",
      headerAlign: "left",
      width: 200,
      renderCell: (params) => {
        const { ee_details } = params?.row;
        return (
          <Box sx={{ textAlign: "left", fontSize: "12px" }}>
            <Box>
              <strong>Supplier Name:</strong> {ee_details?.supplier_name || "-"}
            </Box>
            <Box>
              <strong>Assembly Number:</strong>{" "}
              {ee_details?.assembly_number || "-"}
            </Box>
            <Box>
              <strong>Version:</strong> {ee_details?.version || "-"}
            </Box>
            <Box>
              <strong>Description:</strong> {ee_details?.description || "-"}
            </Box>
            {params?.row?.allData?.dependencies?.ee_components ? (
              <Box sx={{ textAlign: "left", marginTop: 2, fontSize: "10px" }}>
                <Button
                  variant="contained"
                  onClick={() => handleEEViewButtonClick(params?.row?.allData)}
                  sx={{ ...appTheme.commonBtnStyle, fontSize: "10px" }}
                  size="small"
                >
                  View more{" >>"}
                </Button>
              </Box>
            ) : null}
          </Box>
        );
      },
    },
    {
      field: "description",
      headerName: "DESCRIPTION",
      headerAlign: "center",
      width: 250,
      renderCell: (params) => <DescriptionCell value={params?.value || "-"} />,
    },
    {
      field: "created_by",
      headerName: "OWNER",
      headerAlign: "center",
      width: 150,
      renderCell: (params) => (
        <Box sx={{ textAlign: "center", fontSize: "12px" }}>
          {getUserFullNameById(params?.value || "-")}
        </Box>
      ),
    },
  ];

  const EE_COLUMNS = [
    {
      field: "assembly_number",
      headerName: "ASSEMBLY NUMBER",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>{params?.value || "-"}</Box>
      ),
    },
    {
      field: "supplier_name",
      headerName: "SUPPLIER NAME",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>{params?.value || "-"}</Box>
      ),
    },
    {
      field: "description",
      headerName: "DESCRIPTION",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>{params?.value || "-"}</Box>
      ),
    },
    {
      field: "version",
      headerName: "VERSION",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>{params?.value || "-"}</Box>
      ),
    },
    {
      field: "created_by",
      headerName: "OWNER",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>
          {getUserFullNameById(params?.value || "-")}
        </Box>
      ),
    },
  ];

  const SWM_COLUMNS = [
    {
      field: "name",
      headerName: "NAME",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>{params?.value || "-"}</Box>
      ),
    },
    {
      field: "version",
      headerName: "VERSION",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>{params?.value || "-"}</Box>
      ),
    },
    {
      field: "description",
      headerName: "DESCRIPTION",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>{params?.value || "-"}</Box>
      ),
    },
    {
      field: "vehicle_functions",
      headerName: "VEHICLE FUNCTIONS",
      flex: 1,
      renderCell: (params) => {
        const vehicleFunctions = params?.row?.vehicle_functions || [];
        const defaultValue =
          vehicleFunctions.length > 0 ? vehicleFunctions[0].name : "";

        return (
          <FormControl fullWidth>
            {/* Vehicle Functions Section */}
            {vehicleFunctions.length > 0 ? (
              <>
                <Select
                  value={defaultValue}
                  displayEmpty
                  sx={{ height: "30px", fontSize: "12px" }}
                  renderValue={(selected) =>
                    selected ? selected : "VEHICLE FUNCTIONS"
                  }
                >
                  {vehicleFunctions?.map((func, index) => (
                    <MenuItem
                      sx={{ fontSize: "12px" }}
                      key={index}
                      value={func.name}
                    >
                      {func.name} ({func.abbreviation})
                    </MenuItem>
                  ))}
                </Select>
              </>
            ) : (
              <Typography>No Vehicle Functions Available</Typography>
            )}
          </FormControl>
        );
      },
    },

    {
      field: "created_by",
      headerName: "OWNER",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ fontSize: "12px" }}>
          {getUserFullNameById(params?.value || "-")}
        </Box>
      ),
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <Grid container spacing={2}>
            {/* Placeholder content for Tickets tab */}
            <Grid item xs={12}>
              <Card
                sx={{
                  width: "100%",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  boxShadow: "3",
                }}
              >
                {/* Container for the Table */}
                <Box sx={styles.box}>
                  {ticketTableRowsData && ticketTableRowsData.length > 0 ? (
                    <Paper sx={styles.paper}>
                      <CustomDataGridTableB
                        tableRowsData={ticketTableRowsData}
                        columns={TICKET_COLUMNS}
                        isMultiLine={true}
                        handleTableRowClick={() => null}
                        disableDensity={true}
                      />
                    </Paper>
                  ) : (
                    <Typography sx={{ padding: 2, textAlign: "center" }}>
                      No tickets available.
                    </Typography>
                  )}
                </Box>
              </Card>
            </Grid>
          </Grid>
        );
      case 1:
        return (
          <Grid container spacing={2}>
            {/* Placeholder content for eeComponent tab */}
            <Grid item xs={12}>
              <Card
                sx={{
                  width: "100%",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  boxShadow: "3",
                }}
              >
                {/* Container for the Table */}
                <Box sx={styles.box}>
                  {eeCTableRowsData && eeCTableRowsData.length > 0 ? (
                    <Paper sx={styles.paper}>
                      <CustomDataGridTableB
                        tableRowsData={eeCTableRowsData}
                        columns={EE_COLUMNS}
                        isMultiLine={true}
                        handleTableRowClick={() => null}
                      />
                    </Paper>
                  ) : (
                    <Typography sx={{ padding: 2, textAlign: "center" }}>
                      EE Component Not available.
                    </Typography>
                  )}
                </Box>
              </Card>
            </Grid>
          </Grid>
        );
      case 2:
        return (
          <Grid container spacing={2}>
            {/* Placeholder content for Software Modules tab */}
            <Grid item xs={12}>
              <Card
                sx={{
                  width: "100%",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  boxShadow: "3",
                }}
              >
                {/* Container for the Table */}
                <Box sx={styles.box}>
                  {swMTableRowsData && swMTableRowsData.length > 0 ? (
                    <Paper sx={styles.paper}>
                      <CustomDataGridTableB
                        tableRowsData={swMTableRowsData}
                        columns={SWM_COLUMNS}
                        isMultiLine={true}
                        handleTableRowClick={() => null}
                      />
                    </Paper>
                  ) : (
                    <Typography sx={{ padding: 2, textAlign: "center" }}>
                      Sofware Modules Not available.
                    </Typography>
                  )}
                </Box>
              </Card>
            </Grid>
          </Grid>
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        px: 2,
        pt: 1,
        pb: 12,
      }}
    >
      <Box sx={{ width: "100%", display: "flex", mb: 1, ml: 1 }}>
        <Typography sx={{ ...componentStyle?.font?.tabLevelHeader }}>
          Dashboard
        </Typography>
      </Box>
      {!techUser ? (
        <Box sx={styles.topContainer}>
          <ProjectVariantSearchbar />
          <Box></Box>
          {/*  Push button to right side */}
          <Box sx={{ marginLeft: "auto" }}>
            <CustomButtonV2
              btnName="Generate Report"
              handleOnClick={() => setGenerateOpen(true)}
            />
          </Box>
        </Box>
      ) : null}

      <Grid container spacing={2}>
        {/* Homologation status */}
        <Grid item xs={12} md={4}>
          <GraphCard
            heading={
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >

                <CustomFilterV2
                  anchorEl={anchorElHsFilter}
                  open={openHsFilter}
                  iconicFilter={true}
                  border={false}
                  widthPerColumn={"350px"}
                  handleClick={handleHsFilterIconClick}
                  handleFilterButton={handleHsFilterButton}
                  handleClose={handleHsFilterIconClose}
                  actionButtonStyle={{
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                  sections={[
                    {
                      heading: "Homologation Status",
                      content: (
                        <Box
                          sx={{
                            width: "100%",
                            p: 2,
                            justifyContent: "center",
                          }}
                        >
                          <CustomSelectV2
                            optionsList={hsVfOptionsList}
                            // selectedValue={selectedHsVf}
                            selectedValue={hsFilteredData}
                            handleOnChange={(e) => {
                              console.log(
                                "hs filter value",
                                e.target.value,
                                hsVfOptionsList,
                              );
                              setHsFilteredData(e.target.value);
                            }}
                            label={"Select Vehicle Function."}
                          />
                        </Box>
                      ),
                    },
                  ]}
                />
                <Typography sx={{ ...componentStyle.font.cardHeadder, mt: 1 }}>
                  Homologation Status
                </Typography>
              </Box>
            }
          >
            <HomologationStatusGraph data={homologationStatus} />
          </GraphCard>


        </Grid>

        {/* Tickets status */}
        <Grid item xs={12} md={4}>
          <GraphCard
            heading={
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >
                <CustomFilterV2
                  anchorEl={anchorElTsFilter}
                  iconicFilter={true}
                  border={false}
                  widthPerColumn={"350px"}
                  handleClose={handleTsFilterIconClose}
                  open={openTsFilter}
                  handleClick={handleTsFilterIconClick}
                  handleFilterButton={handleTSFilterButton}
                  actionButtonStyle={{
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                  sections={[
                    {
                      heading: "Ticket Status",
                      content: (
                        <Box
                          sx={{
                            width: "100%",
                            p: 2,
                            justifyContent: "center",
                          }}
                        >
                          <CustomSelectV2
                            optionsList={tsVfOptionsList}
                            selectedValue={tsFilteredData}
                            handleOnChange={(e) =>
                              setTsFilteredData(e.target.value)
                            }
                            label={"Select Vehicle Function"}
                          />
                        </Box>
                      ),
                    },
                  ]}
                />
                <Typography sx={{ ...componentStyle.font.cardHeadder, mt: 1 }}>
                  Tickets Status
                </Typography>
              </Box>
            }
          >
            <BarGraph data={ticketsStatus} />
          </GraphCard>

        </Grid>

        {/* User level tickets */}
        <Grid item xs={12} md={4}>
          <GraphCard
            heading={
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >


                <CustomFilterV2
                  anchorEl={anchorElUltFilter}
                  open={openUltFilter}
                  iconicFilter={true}
                  border={false}
                  widthPerColumn={"350px"}
                  handleClick={handleUltFilterIconClick}
                  handleClose={handleUltFilterIconClose}
                  handleFilterButton={handleUltFilterButton}
                  actionButtonStyle={{
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                  sections={[
                    {
                      heading: "User Level Tickets",
                      content: (
                        <Box
                          sx={{
                            width: "100%",
                            p: 2,
                            // alignContent: "center",
                            justifyContent: "center",
                          }}
                        >
                          <CustomSelectV2
                            optionsList={ultUsersOptionsList}
                            // selectedValue={selectedUltUser}
                            selectedValue={ultFilteredData}
                            handleOnChange={(e) =>
                              // setSelectedUltUser(e.target.value)
                              setUltFilteredData(e.target.value)
                            }
                            label={"Select Users"}
                          />
                        </Box>
                      ),
                    },
                  ]}
                />
                <Typography sx={{ ...componentStyle.font.cardHeadder, mt: 1 }}>
                  User Level Tickets
                </Typography>
              </Box>
            }
          >
            <BarGraph data={userLevelTickets} />
          </GraphCard>

        </Grid>
      </Grid>

      {/* ----------------------Bharathan------------------------------- */}
      <Box
        sx={{
          mt: 2,
        }}
      >
        <RecentActivities
          recentEEComponent={"Recent EE Component"}
          recentSoftwareModule={"Recent Software Module"}
          recentVehicle={"Recent Vehicle"}
        />
      </Box>

      <Dialog
        open={generateOpen}
        onClose={() => setGenerateOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Select Template</DialogTitle>

        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <CustomSelectV2
              label={"Template"}
              optionsList={templates.map((template) => ({
                label: template.name,
                value: template.id,
              }))}
              selectedValue={selectedTemplateId}
              handleOnChange={(e) => setSelectedTemplateId(e.target.value)}
              dark={false}
              showLabel={true}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <CustomButtonV2
            type="cancel"
            size="small"
            btnName={"Close"}
            handleOnClick={() => setGenerateOpen(false)}
          />

          <CustomButtonV2
            type="submit"
            size="small"
            btnName={"Download Report"}
            disabled={!selectedTemplateId || loadingGenerate}
            handleOnClick={handleGenerate}
          >
            {loadingGenerate ? "Generating..." : "Generate"}
          </CustomButtonV2>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Home;

//Constants to handle ticket status

const ticketStatus = {
  100: (
    <Chip
      sx={{
        fontWeight: "bold",
        // boxShadow: "3",
        // borderRadius: "5px",
        // backgroundColor: "#000000",
        background: "none",
        color: "#000000",
        fontSize: "12px",
      }}
      label={"NEW"}
    // size="small"
    />
  ),
  101: (
    <Chip
      sx={{
        fontWeight: "bold",
        // boxShadow: "3",
        // borderRadius: "5px",
        // backgroundColor: "#0076a8",
        background: "none",
        color: "#0076a8",
        fontSize: "12px",
      }}
      label={"DRAFT"}
    // size="small"
    />
  ),
  200: (
    <Chip
      sx={{
        fontWeight: "bold",
        // boxShadow: "3",
        // borderRadius: "5px",
        // backgroundColor: "#0076a8",
        background: "none",
        color: "#0076a8",
        fontSize: "12px",
      }}
      label={"ARTIFACT CONFIRMATION"}
    // size="small"
    />
  ),
  300: (
    <Chip
      sx={{
        fontWeight: "bold",
        // boxShadow: "3",
        // borderRadius: "5px",
        // backgroundColor: "#0076a8",
        background: "none",
        color: "#0076a8",
        fontSize: "12px",
      }}
      label={"EVIDENCE SUBMISSION"}
    // size="small"
    />
  ),
  400: (
    <Chip
      sx={{
        fontWeight: "bold",
        // boxShadow: "3",
        // borderRadius: "5px",
        // backgroundColor: "#0076a8",
        background: "none",
        color: "#0076a8",
        fontSize: "12px",
      }}
      label={"EVIDENCE REVIEW"}
    // size="small"
    />
  ),
  500: (
    <Chip
      sx={{
        fontWeight: "bold",
        // boxShadow: "3",
        // borderRadius: "5px",
        background: "none",
        // backgroundColor: "#0076a8",
        color: "#0076a8",
        fontSize: "12px",
      }}
      label={"TESTING AT TA reviewers"}
    // size="small"
    />
  ),
  600: (
    <Chip
      sx={{
        fontWeight: "bold",
        // boxShadow: "3",
        // borderRadius: "5px",
        // backgroundColor: "#26890D",
        background: "none",
        color: "#26890D",
        fontSize: "12px",
      }}
      label={"RESOLVED"}
    // size="small"
    />
  ),
};

//Function to minimize the length of the description for legal requirement
const ExpandableDescription = ({ description }) => {
  const maxLength = 15;
  const [isExpanded, setIsExpanded] = useState(false);

  // Function to toggle the description view
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  const displayText =
    isExpanded || !description || description.length <= maxLength
      ? description
      : `${description.substring(0, maxLength)}...`;

  return (
    <Box sx={{ textAlign: "justify" }}>
      <Typography sx={{ fontSize: "12px" }}>
        {displayText}
        {description && description.length > maxLength && (
          <Button
            onClick={handleToggle}
            sx={{ textTransform: "none", p: 0, fontSize: "12px" }}
          >
            {isExpanded ? "Show Less" : "Show More"}
          </Button>
        )}
      </Typography>
    </Box>
  );
};

//Function to minimize the length of the project description
const DescriptionCell = ({ value }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 100;
  // Function to toggle the description view
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  const displayText =
    isExpanded || !value || value.length <= maxLength
      ? value
      : `${value.substring(0, maxLength)}...`;
  return (
    <Box sx={{ textAlign: "justify", fontSize: "12px" }}>
      <Typography sx={{ fontSize: "12px" }}>
        {displayText || "No Description for the selected project"}
        {value && value.length > maxLength && (
          <Button
            onClick={handleToggle}
            sx={{ textTransform: "none", p: 0, fontSize: "12px" }}
          >
            {isExpanded ? "Show Less" : "Show More"}
          </Button>
        )}
      </Typography>
    </Box>
  );
};

// Styles
const styles = {
  chartsContainer: {
    width: "100%",
    borderRadius: "10px",
    // border: "1px solid grey",
    boxShadow: 6,
    px: 2.5,
    pt: 1,
  },
  topContainer: {
    textAlign: "start",
    display: "flex",
    // justifyContent: "center",
    mb: 3,
    ml: 1,
    gap: 4,
  },
  searchSelectTextField: {
    width: "215px",
    backgroundColor: "white",
  },
  stfNContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  selectTxtStyle: {
    width: "190px",
  },
  // --------------------Bharathan-----------------------------
  box: {
    height: "350px",
  },
  paper: {
    boxShadow: 3,
    height: "350px",
    scrollbarColor: "#888 #f1f1f1",
  },
  filter: {
    position: "relative",
    top: "4px",
    right: "8px",
  },
  mainBox: {
    pt: 0,
    boxShadow: 3,
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    height: "100vh",
    pr: 2,
    pl: 2,
  },
  drawerContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "400px",
    maxHeight: "500px",
    padding: 2,
    position: "relative",
  },
  closeButton: {
    color: "red",
    position: "absolute",
    top: "4px",
    right: "8px",
  },
  divider: {
    border: "1px solid lightgrey",
    margin: "8px 0",
    marginY: 1,
  },
  paperDrawer: {
    marginBottom: 2,
    padding: 2,
    boxShadow: 10,
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
  },
  drawerWrap: {
    marginTop: 2,
  },

  dataTypographyKey: {
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "left",
    minWidth: "110px",
  },
  dataTypographyValue: {
    marginLeft: 1,
    fontSize: "14px",
    textAlign: "left",
  },
  dataBox: {
    display: "flex",
    flexDirection: "row",

    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
  },
  cardContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "100%",
  },
  card: {
    boxShadow: 3,
    width: "100%",
    height: "auto",
    marginBottom: 1,
    padding: 2,
  },
  cardContent: {
    display: "flex",
    height: "40px",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dataTypography: {
    fontWeight: "bold",
    fontSize: "13px",
    textAlign: "left",
    minWidth: "120px",
  },
  dataTypographyCardKey: {
    fontWeight: "bold",
    fontSize: "15px",
    textAlign: "left",
    minWidth: "50px",
  },
  dataTypographyCardValue: {
    fontSize: "15px",
    textAlign: "left",
    minWidth: "50px",
  },
  btnsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    mb: 1,
    gap: 1,
  },
  cardDrawer: { margin: 1, padding: 2, boxShadow: 3 },
  paginationPaper: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "5px",
  },
  searchContainer: {
    textAlign: "start",
    mt: { xs: 2, md: 0 },
  },
};
